module.exports = __webpack_public_path__ + "static/media/taysir.db7d1081.jpg";